var youtubeplayer;
var tag = document.createElement('script');
tag.id = 'iframe-youtube-api';
tag.src = 'https://www.youtube.com/iframe_api';
tag.async = true;
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

function onYoutubeplayerStateChangeVideoEntry(newState) {
   if(newState.data == YT.PlayerState.ENDED){
		var published_date = $("#ytplayer").data("published");
    	var videovertical = $("#ytplayer").data("videovertical");
    	get_next_video(published_date, videovertical); 
    }
}